/* eslint-disable jsx-a11y/anchor-is-valid */
import { useTranslation } from 'react-i18next';
import type { Theme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import makeStyles from '@mui/styles/makeStyles';

import NoLicenseInventories from '@experimental-components/IconsComponents/States/NoLicenseInventories';

import { env } from 'utils/inventories/env';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    margin: '0 auto',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 0,
    height: '100vh',
    [theme.breakpoints.down('md')]: {
      padding: 16,
    },
  },
  subtitle: {
    textAlign: 'center',
  },
  link: {
    cursor: 'pointer',
    lineHeight: '1',
    whiteSpace: 'nowrap',
    color: theme.palette.secondary.main,
  },
}));

function NoLicense() {
  const { t } = useTranslation('inventories');
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Box alignItems="center" display="flex" flexDirection="column" height="100%" justifyContent="center" width="100%">
        <NoLicenseInventories />
        <Box fontSize={32} fontWeight="fontWeightMedium" mb={3} mt="3rem" textAlign="center">
          {t('inventories:messages.titleDemoLicense')}
        </Box>
        <Box className={classes.subtitle} fontSize={24} fontWeight="fontWeightMedium" width="100%">
          <Link className={classes.link} href={env.urlDemo} rel="noopener" target="_blank">
            <Box component="span">{t('inventories:messages.linkDemo')}</Box>
          </Link>
          <Box component="span" ml={1}>
            {t('inventories:messages.subtitleDemoLicense')}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default NoLicense;
